// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Descriptif financier (DPGF) — fork acheteur MS V2 de CreationArticle.
   Styles co-localises (l'oracle CreationArticle.css reste intact pour le legacy).
   Classes reprises a l'identique pour conserver le rendu visuel exact. */

.delete-button,
.add-button {
  width: 2.4rem;
  height: 2.4rem;
  border-radius: 50%;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 2rem;
}

.delete-button {
  background-color: #fee2e2;
  color: #dc2626;
  margin-left: auto;
  min-width: 2.4rem;
  min-height: 2.4rem;
  max-width: 2.4rem;
  max-height: 2.4rem;
  flex-shrink: 0;
  box-sizing: border-box;
}

.delete-button.loading {
  width: 2.4rem;
  height: 2.4rem;
  min-width: 2.4rem;
  min-height: 2.4rem;
  max-width: 2.4rem;
  max-height: 2.4rem;
}

.delete-button.loading .button-loader {
  border-color: #dc2626;
  border-top-color: transparent;
}

.add-button {
  background-color: #dcfce7;
  color: #16a34a;
  width: 2.4rem;
  height: 2.4rem;
  min-width: 2.4rem;
  min-height: 2.4rem;
  max-width: 2.4rem;
  max-height: 2.4rem;
  border-radius: 50%;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 2rem;
  position: relative;
  flex-shrink: 0;
  box-sizing: border-box;
}

.add-button:disabled {
  cursor: not-allowed;
  opacity: 0.7;
}

.button-loader {
  width: 1.6rem;
  height: 1.6rem;
  border: 2px solid #16a34a;
  border-top: 2px solid transparent;
  border-radius: 50%;
  animation: opms-spin 1s linear infinite;
}

@keyframes opms-spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.add-button.loading {
  background-color: #dcfce7;
  color: transparent;
  width: 2.4rem;
  height: 2.4rem;
  min-width: 2.4rem;
  min-height: 2.4rem;
  max-width: 2.4rem;
  max-height: 2.4rem;
}

.add-section .add-button.loading .button-loader {
  border-color: #16a34a;
  border-top-color: transparent;
}

.add-article .add-button.loading .button-loader {
  border-color: #16a34a;
  border-top-color: transparent;
}

.sections-container {
  margin: 2rem 0;
}

.add-section {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 2rem;
}

.add-section input {
  padding: 1rem;
  width: 300px;
}

.section {
  margin-bottom: 2rem;
  border: 1px solid #e5e7eb;
  border-radius: 1rem;
  overflow: hidden;
}

.articles-list {
  padding: 1.2rem;
}

.add-article {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-top: 1rem;
}

.add-article input {
  padding: 1rem;
  width: 95%;
}

.add-article-button {
  width: 100%;
  padding: 1rem;
  background: none;
  border: 2px dashed #e5e7eb;
  border-radius: 0.4rem;
  color: #6b7280;
  cursor: pointer;
  margin-top: 1rem;
}

.add-article-button:hover {
  border-color: #f97316;
  color: #f97316;
}

.numero-article {
  width: 10rem;
}

.titre-article {
  display: flex;
  justify-content: space-between;
  background-color: rgba(194, 194, 194, 0.5);
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  padding: 1rem;
  color: #2c3948;
}

.view-mode .section {
  margin-bottom: 2rem;
}

.empty-sections-message {
  padding: 2rem;
  background-color: #f3f4f6;
  border-radius: 0.5rem;
  text-align: center;
}

.step-container {
  padding: 2rem 0 0;
}
`, "",{"version":3,"sources":["webpack://./src/pages/SuiviOperationMSV2/components/OperationCreationArticle.css"],"names":[],"mappings":"AAAA;;yEAEyE;;AAEzE;;EAEE,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,cAAc;EACd,yBAAyB;EACzB,iCAAiC;EACjC,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,0BAA0B;EAC1B,qBAAqB;EACrB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,0CAA0C;EAC1C,4BAA4B;EAC5B,6BAA6B;EAC7B,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB","sourcesContent":["/* Descriptif financier (DPGF) — fork acheteur MS V2 de CreationArticle.\n   Styles co-localises (l'oracle CreationArticle.css reste intact pour le legacy).\n   Classes reprises a l'identique pour conserver le rendu visuel exact. */\n\n.delete-button,\n.add-button {\n  width: 2.4rem;\n  height: 2.4rem;\n  border-radius: 50%;\n  border: none;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  font-size: 2rem;\n}\n\n.delete-button {\n  background-color: #fee2e2;\n  color: #dc2626;\n  margin-left: auto;\n  min-width: 2.4rem;\n  min-height: 2.4rem;\n  max-width: 2.4rem;\n  max-height: 2.4rem;\n  flex-shrink: 0;\n  box-sizing: border-box;\n}\n\n.delete-button.loading {\n  width: 2.4rem;\n  height: 2.4rem;\n  min-width: 2.4rem;\n  min-height: 2.4rem;\n  max-width: 2.4rem;\n  max-height: 2.4rem;\n}\n\n.delete-button.loading .button-loader {\n  border-color: #dc2626;\n  border-top-color: transparent;\n}\n\n.add-button {\n  background-color: #dcfce7;\n  color: #16a34a;\n  width: 2.4rem;\n  height: 2.4rem;\n  min-width: 2.4rem;\n  min-height: 2.4rem;\n  max-width: 2.4rem;\n  max-height: 2.4rem;\n  border-radius: 50%;\n  border: none;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  font-size: 2rem;\n  position: relative;\n  flex-shrink: 0;\n  box-sizing: border-box;\n}\n\n.add-button:disabled {\n  cursor: not-allowed;\n  opacity: 0.7;\n}\n\n.button-loader {\n  width: 1.6rem;\n  height: 1.6rem;\n  border: 2px solid #16a34a;\n  border-top: 2px solid transparent;\n  border-radius: 50%;\n  animation: opms-spin 1s linear infinite;\n}\n\n@keyframes opms-spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.add-button.loading {\n  background-color: #dcfce7;\n  color: transparent;\n  width: 2.4rem;\n  height: 2.4rem;\n  min-width: 2.4rem;\n  min-height: 2.4rem;\n  max-width: 2.4rem;\n  max-height: 2.4rem;\n}\n\n.add-section .add-button.loading .button-loader {\n  border-color: #16a34a;\n  border-top-color: transparent;\n}\n\n.add-article .add-button.loading .button-loader {\n  border-color: #16a34a;\n  border-top-color: transparent;\n}\n\n.sections-container {\n  margin: 2rem 0;\n}\n\n.add-section {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  margin-bottom: 2rem;\n}\n\n.add-section input {\n  padding: 1rem;\n  width: 300px;\n}\n\n.section {\n  margin-bottom: 2rem;\n  border: 1px solid #e5e7eb;\n  border-radius: 1rem;\n  overflow: hidden;\n}\n\n.articles-list {\n  padding: 1.2rem;\n}\n\n.add-article {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  margin-top: 1rem;\n}\n\n.add-article input {\n  padding: 1rem;\n  width: 95%;\n}\n\n.add-article-button {\n  width: 100%;\n  padding: 1rem;\n  background: none;\n  border: 2px dashed #e5e7eb;\n  border-radius: 0.4rem;\n  color: #6b7280;\n  cursor: pointer;\n  margin-top: 1rem;\n}\n\n.add-article-button:hover {\n  border-color: #f97316;\n  color: #f97316;\n}\n\n.numero-article {\n  width: 10rem;\n}\n\n.titre-article {\n  display: flex;\n  justify-content: space-between;\n  background-color: rgba(194, 194, 194, 0.5);\n  border-top-left-radius: 10px;\n  border-top-right-radius: 10px;\n  padding: 1rem;\n  color: #2c3948;\n}\n\n.view-mode .section {\n  margin-bottom: 2rem;\n}\n\n.empty-sections-message {\n  padding: 2rem;\n  background-color: #f3f4f6;\n  border-radius: 0.5rem;\n  text-align: center;\n}\n\n.step-container {\n  padding: 2rem 0 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
